import { Component, Inject, OnInit, Optional } from '@angular/core';
import { HelplistService } from 'app/helplist.service';
import { AddNewSurgeryComponent } from '../add-new-surgery/add-new-surgery.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { AuthService } from 'app/auth/auth.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';

@Component({
  selector: 'app-comman-surgery-popup',
  templateUrl: './comman-surgery-popup.component.html',
  styleUrls: ['./comman-surgery-popup.component.scss']
})
export class CommanSurgeryPopupComponent implements OnInit {
  helplistsergery = [];
  eyetype: string;
  stype: any;
  disablesitel: boolean = true;
  disablesiter: boolean = true;
  disablesiteb: boolean = true;
  disablesiten: boolean = false;
  constructor(private emrservice: EMRService, private helplistservice: HelplistService, private dialog: MatDialog, private opdvisitService: OpdVisitService,
    private authService: AuthService, private dashboardService: DashboardService, private dialogRef: MatDialogRef<CommanSurgeryPopupComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.stype = 'S';
    this.eyetype = 'None';
    this.helplistsergery = this.helplistservice.surgeryList.filter(item => item.isActive == true);
    this.helplistsergery.map(item => item.isEdit = null);
  }
  searchType(event) {
    this.stype = event;
  }
  checkdisable(type2) {
    if (type2 == 1) {
      this.eyetype = 'LE'
      this.disablesitel = false
      this.disablesiter = true;
      this.disablesiteb = true;
      this.disablesiten = true;

    } else if (type2 == 2) {
      this.eyetype = 'RE'
      this.disablesitel = true
      this.disablesiter = false;
      this.disablesiteb = true;
      this.disablesiten = true;
    } else if (type2 == 3) {
      this.eyetype = 'BE'
      this.disablesitel = true
      this.disablesiter = true;
      this.disablesiteb = false;
      this.disablesiten = true;
    } else if (type2 == 4) {
      this.eyetype = 'None'
      this.disablesitel = true
      this.disablesiter = true;
      this.disablesiteb = true;
      this.disablesiten = false;
    }
  }
  filerdata(items: any[], searchText: string) {
    if (this.stype == 'S') {
      let smallchar=searchText?searchText.toLowerCase():'';
      return items ? items.filter(item => item.surgeryName?.toLowerCase().indexOf(smallchar) === 0):[];
    } else {
      return items ? items.filter(item => item.surgeryName.search(new RegExp(searchText, 'i')) > -1) : [];
    }

  }
  filtersurgerydata(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (event.target.value.length >= 3) {
        this.emrservice.GetSurgeryAll(event.target.value, this.stype).subscribe((item: any) => {
          this.helplistsergery = item;
        },err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })
      }
    } else {
      const finddata = this.filerdata(this.helplistservice.surgeryList.slice(), event.target.value);
      if (finddata.length > 0) {
        this.helplistsergery = finddata;
      } else {
        this.helplistsergery = [];
        if (event.target.value.length >= 3) {
          if (event.target.value != null && event.target.value != '') {
            var pdata = event.target.value
          } else {
            pdata = 0;
          }
          this.emrservice.GetSurgeryAll(pdata, this.stype).subscribe((item: any) => {
            this.helplistsergery = item;
          },err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } 
            else if(err.error.statusCode == 422){
              this.dashboardService.openSnackBar(err.error.message,"OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
        }
      }
    }
  }
  AddNewsurgeriespopup(): void {
    const dialogRef = this.dialog.open(AddNewSurgeryComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '60vw',
      height: 'auto',
      width: '60%',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != 0) {
        // this.getallsurgeries();
      }

    });
  }
  selectedSugeryArray: any = [];
  showSurgeryOptions(event: MatCheckboxChange, row: any, i): void {

    if (event.checked == true) {
      this.helplistsergery[i].isEdit = false;
      this.selectedSugeryArray.push({
        ...row,
        'eye': this.eyetype,
      });

    } else {
      this.helplistsergery[i].isEdit = null;
      this.selectedSugeryArray = this.selectedSugeryArray.filter(item => item.pkSurgeryId != row.pkSurgeryId);

    }

  }
  selectDeleterow(row: any) {
    const index: number = this.selectedSugeryArray.indexOf(row);
    if (index !== -1) {
      const findindex = this.helplistsergery.findIndex(item => item.pkSurgeryId == row.pkSurgeryId);
      this.helplistsergery[findindex].isEdit = null;
      this.selectedSugeryArray.splice(index, 1);
    }
  }
  transferDataMain() {

    if (this.selectedSugeryArray.length > 0) {
      this.dialogRef.close(this.selectedSugeryArray);

    } else {
      this.dashboardService.openSnackBar("Please Select Surgery", "OK");
    }
  }
  closedialog() {
    this.dialogRef.close([]);
  }

}
